import * as React from 'react'
import Button from 'components/ui/button'
import ButtonContainer from 'components/ui/button-container'
import styles from './index.module.css'

type Props = {
  primary?: React.ReactNode
  secondary?: React.ReactNode
  corner?: React.ReactNode
  onClose?: (...args: Array<any>) => any
  footerMargin?: number
}
export default function DialogFooter(props: Props): React.ReactElement<'div'> {
  return (
    <div
      className={styles.dialogFooterBottomRow}
      data-footer-margin={props.footerMargin}
    >
      {props.secondary}
      <div className={styles.dialogFooterBottomCorner}>{props.corner}</div>
      {props.onClose ? (
        <ButtonContainer>
          <Button onClick={props.onClose} caption="Cancel" />
          {props.primary}
        </ButtonContainer>
      ) : (
        <span>{props.primary}</span>
      )}
    </div>
  )
}
